// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"az_jFc","legal":"az_kFc"};